import { Component } from '@angular/core';

/**
 * Generated class for the MenuPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */


@Component({
  selector: 'page-menu',
  templateUrl: 'menu.html',
})
export class MenuPage {

  constructor() {
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad MenuPage');
  }


}



// WEBPACK FOOTER //
// ./src/pages/employee/menu/menu.ts